import * as XLSX from 'xlsx-js-style'; // Biblioteca para exportar a Excel

/**
 * Función para exportar los detalles a un archivo Excel con bordes gruesos y columnas autoajustadas
 * @param {Object} detalle - Los datos con las ubicaciones y productos.
 */
const exportarUbicacionesAExcel = (detalle) => {
    const wsData = [];
    const merges = []; // Array para almacenar las celdas que serán combinadas
    const cellStyles = {}; // Objeto para aplicar estilos a las celdas específicas

    // Recorrer los datos y agregar cada ubicación con sus productos
    for (const [ubicacion, productos] of Object.entries(detalle)) {
        const startRow = wsData.length; // Fila donde empieza la ubicación

        // Título de la ubicación (combinar celdas A y B)
        wsData.push([`Ubicación: ${ubicacion}`, '']); // Columna A y B

        // Aplicar borde grueso a las celdas A y B de la ubicación combinada
        ['A', 'B'].forEach(col => {
            cellStyles[`${col}${startRow + 1}`] = {
                border: {
                    top: { style: 'thick' },
                    left: { style: 'thick' },
                    bottom: { style: 'thick' },
                    right: { style: 'thick' }
                },
                alignment: { vertical: 'center', horizontal: 'center' }
            };
        });

        // Agregar la combinación horizontal en las celdas A y B de la fila de la ubicación
        merges.push({
            s: { r: startRow, c: 0 },  // Fila de inicio, columna A
            e: { r: startRow, c: 1 },  // Fila de inicio, columna B
        });

        // Cabecera de columnas
        wsData.push(['Descripción', 'EPC', 'Fecha de Creación', 'Estado']);

        // Aplicar borde grueso a la cabecera de los títulos
        ['A', 'B', 'C', 'D'].forEach(col => {
            cellStyles[`${col}${wsData.length}`] = {
                border: {
                    top: { style: 'thick' },
                    left: { style: 'thick' },
                    bottom: { style: 'thick' },
                    right: { style: 'thick' }
                },
                font: { bold: true }, // Negrita para los títulos
                alignment: { vertical: 'center', horizontal: 'center' }
            };
        });

        // Detalles de productos
        if (Array.isArray(productos) && productos.length > 0) {
            productos.forEach(producto => {
                wsData.push([
                    producto.DescripcionProducto,
                    producto.epc,
                    producto.fecha_creacion,
                    producto.EstadoProducto
                ]);

                // Aplicar bordes normales a las celdas de productos
                const rowIndex = wsData.length; // Fila actual
                ['A', 'B', 'C', 'D'].forEach(col => {
                    const cellKey = `${col}${rowIndex}`;
                    cellStyles[cellKey] = {
                        border: {
                            top: { style: 'thin' },
                            left: { style: 'thin' },
                            bottom: { style: 'thin' },
                            right: { style: 'thin' }
                        }
                    };
                });
            });
        }

        // Dejar una fila vacía entre ubicaciones
        wsData.push([]);
    }

    // Crear la hoja de trabajo con los datos
    const ws = XLSX.utils.aoa_to_sheet(wsData);

    // Aplicar las combinaciones de celdas
    ws['!merges'] = merges;

    // Aplicar los estilos (bordes gruesos para las celdas de título y ubicación, bordes normales para el resto)
    for (const cell in cellStyles) {
        if (ws[cell]) {
            ws[cell].s = cellStyles[cell];
        }
    }

    // Ajustar el ancho de las columnas automáticamente
    const colWidths = [];
    const numCols = wsData[0] ? wsData[0].length : 0;

    // Calcular el ancho máximo de cada columna
    for (let col = 0; col < numCols; col++) {
        let maxWidth = 0;

        // Recorrer todas las filas y encontrar la longitud máxima de texto por columna
        for (let row = 0; row < wsData.length; row++) {
            if (wsData[row] && wsData[row][col]) {
                const cellValue = wsData[row][col].toString(); // Asegurarse de que el valor sea una cadena
                maxWidth = Math.max(maxWidth, cellValue.length); // Obtener la longitud máxima
            }
        }

        colWidths.push({ wch: maxWidth + 2 }); // Añadir un margen adicional
    }

    // Asignar los anchos de las columnas a la hoja de trabajo
    ws['!cols'] = colWidths;

    // Crear un libro de trabajo y agregar la hoja
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Inventarios por Ubicación');

    // Generar el archivo Excel y disparar la descarga
    XLSX.writeFile(wb, 'DetallesUbicaciones.xlsx');
};

export default exportarUbicacionesAExcel;
